import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2baaea20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-width":"135px"} }
const _hoisted_2 = {
  key: 0,
  class: "gordita-400-12 brand_almost_black"
}

import elementIds from '@/const/elementIds.json';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import { inject, ref } from 'vue';
import IncrediTransition from '@/components/incredi-transition/incredi-transition.vue';
import COLORS from '@/design-system/colors.json';
import { useMatomo } from '@/services/matomo/matomo.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-bar-search-input',
  setup(__props) {

const agentsFilter = inject(IKAgentsDrawerFilter);
const expandSearchBar = ref(false);
const isSearchInputEllipsis = ref(false);
const searchInput = ref(null);
const matomo = useMatomo();

const checkSearchInputEllipsis = () => {
  const searchInputEl = (searchInput.value as any)?.$el?.getElementsByTagName('input')[0];
  return searchInputEl?.offsetWidth < searchInputEl?.scrollWidth;
};
const hidePlaceholder = ref(false);
const handleSearchBlur = () => {
  expandSearchBar.value = false;
  hidePlaceholder.value = true;
  setTimeout(() => {
    hidePlaceholder.value = false;
  }, 400);
  matomo?.trackEvent({
    category: 'Agents Page',
    action: 'Select search',
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(IncrediTransition, {
    class: "search-nav table-upper-buttons",
    "data-testid": "agents-search-nav",
    style: _normalizeStyle({
      transition: 'max-width 0.2s,background 0.2s',
      maxWidth: !_unref(agentsFilter)?.GQL_AgentsFilter.value.searchFilter && !expandSearchBar.value ? '86px' : '280px',
      width: expandSearchBar.value ? '280px' : '218px', //this gets to the figma's length when closed with search input.
      background: _unref(agentsFilter)?.GQL_AgentsFilter.value.searchFilter && !expandSearchBar.value ? _unref(COLORS)['Hovers/hover_primary'] : null,
    }),
    onTransitionend: _cache[3] || (_cache[3] = ($event: any) => (isSearchInputEllipsis.value = checkSearchInputEllipsis()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_input, {
        ref: "search-input",
        "data-testid": _unref(elementIds).agents.AgentsSearchInput,
        placeholder: !hidePlaceholder.value ? _ctx.$t('agents.navBar.searchInput.placeholder') : '',
        "model-value": _unref(agentsFilter)?.GQL_AgentsFilter.value.searchFilter,
        "input-style": { color: _unref(COLORS)['Text/Dark'] },
        borderless: "",
        dense: "",
        debounce: "300",
        class: _normalizeClass(["search", { expandSearch: expandSearchBar.value }]),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = 
        $event => {
          _unref(agentsFilter)?.setGQL_AgentsSearchFilter($event);
        }
      ),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (expandSearchBar.value = true)),
        onBlur: handleSearchBlur
      }, {
        append: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_icon, {
            name: "icon-x-small",
            class: "cursor-pointer search-clear-icon",
            "data-testid": _unref(elementIds).agents.AgentsSearchInputClear,
            onClick: _cache[0] || (_cache[0] = 
            () => {
              _unref(agentsFilter)?.setGQL_AgentsSearchFilter('');
            }
          )
          }, null, 8, ["data-testid"]), [
            [_vShow, _unref(agentsFilter)?.GQL_AgentsFilter.value.searchFilter && expandSearchBar.value]
          ])
        ]),
        prepend: _withCtx(() => [
          _createVNode(_component_q_icon, { class: "uil uil-search search-icon" }),
          (!expandSearchBar.value && !_unref(agentsFilter)?.GQL_AgentsFilter.value.searchFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Search "))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (!expandSearchBar.value && isSearchInputEllipsis.value)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                offset: [0, 18],
                anchor: "bottom right",
                self: "center right",
                "content-class": "tooltip-background"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(agentsFilter)?.GQL_AgentsFilter.value.searchFilter), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-testid", "placeholder", "model-value", "input-style", "class"])
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})